import { render, staticRenderFns } from "./footerIndex.vue?vue&type=template&id=68668b3d&scoped=true"
import script from "./footerIndex.vue?vue&type=script&lang=js"
export * from "./footerIndex.vue?vue&type=script&lang=js"
import style0 from "./footerIndex.vue?vue&type=style&index=0&id=68668b3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68668b3d",
  null
  
)

export default component.exports